import React, { useRef } from 'react';
import styled from 'styled-components/macro';

import { viewport } from '../../../../../common/config';
import useAnimation from './useAnimation';

const Letter = styled.span`
  display: inline-block;
  font-size: 60rem;
  margin: 0 1rem;
  font-family: 'Somersby';

  transform: translateY(100%);
  opacity: 0;

  position: relative;
  z-index: 10;

  @media screen and (min-width: ${viewport.sm}) { font-size: 80rem }
  @media screen and (min-width: ${viewport.md}) { font-size: 100rem }
  @media screen and (min-width: ${viewport.lg}) { font-size: 120rem }
`;

const Title = () => {
  const refs = [
    useRef<HTMLSpanElement>(null),
    useRef<HTMLSpanElement>(null),
    useRef<HTMLSpanElement>(null),
    useRef<HTMLSpanElement>(null),
    useRef<HTMLSpanElement>(null),
    useRef<HTMLSpanElement>(null),
    useRef<HTMLSpanElement>(null),
    useRef<HTMLSpanElement>(null)
  ];

  useAnimation(refs);

  return (
    <>
      <Letter ref={refs[0]}>S</Letter>
      <Letter ref={refs[1]}>O</Letter>
      <Letter ref={refs[2]}>M</Letter>
      <Letter ref={refs[3]}>E</Letter>
      <Letter ref={refs[4]}>R</Letter>
      <Letter ref={refs[5]}>S</Letter>
      <Letter ref={refs[6]}>B</Letter>
      <Letter ref={refs[7]}>Y</Letter>
    </>
  );
}

export default Title;